import styled from 'styled-components';
import {device} from '../../../../../utils/device';

export const InputContainer = styled.div(
  props => `
  margin-top: ${props.setMargin ? '20px' : '0px'} !important;
  label {
    display: flex;
    font-size: 16px;
    line-height: 19px;
    font-weight: 700;
    color: #000;
    margin-bottom: ${props.setMargin ? '10px' : '0px'};
  }
  @media ${device.mobileS} {
    label {
      font-size: 14px;
      line-height: 16px;
      margin-bottom: ${props.setMargin ? '10px' : '0px'};
    }
  }
`,
);

export const PasswordInputContainer = styled.div(
  props => `
  margin-top: ${props.setMargin ? '20px' : '0px'} !important;
  label {
    display: flex;
    font-size: 16px;
    line-height: 19px;
    font-weight: 700;
    color: #000;
    margin-bottom: ${props.setMargin ? '10px' : '0px'};
  }
  input{
    background-color: #fff;
    border: 1px #D0D0D0 solid;
    width: 100%;
    padding: 10px 16px;
    border-radius: 4px;
    font-family: 'Lato';
    font-size: 16px;
    color: #2F281E;
    outline: 0;
      ${p =>
        p.haserror &&
        `
        border-color: #FF7B41;
      `}
        @media ${device.mobileS} {
            border-radius: 2px;
        }
    }
  @media ${device.mobileS} {
    label {
      font-size: 14px;
      line-height: 16px;
      margin-bottom: ${props.setMargin ? '10px' : '0px'};
    }
  }
`,
);

export const PasswordInputWrapper = styled.div`
  width: auto;
  background-color: #fff;
      border: 1px #D0D0D0 solid;
      width: 100%;
      display: flex;
      border-radius: 4px;
      font-family: 'Lato';
      font-size: 16px;
      color: #2F281E;
      outline: 0;
  input{
      background-color: #fff;
      border: 1px #D0D0D0 solid;
      width: 100%;
      padding: 10px 16px;
      border-radius: 4px;
      font-family: 'Lato';
      font-size: 16px;
      color: #2F281E;
      outline: 0;
      border: none;
      ${p =>
        p.haserror &&
        `
          border-color: #FF7B41;
      `}
      @media ${device.mobileS} {
          border-radius: 2px;
      }
    }
`;

export const InputWrapper = styled.div`
    width: 100%;
    position: relative;
  
    input{
        background-color: #fff;
        border: 1px #D0D0D0 solid;
        width: 100%;
        padding: 10px 16px;
        border-radius: 4px;
        font-family: 'Lato';
        font-size: 16px;
        color: #2F281E;
        outline: 0;
        ${p =>
          p.haserror &&
          `
            border-color: #FF7B41;
        `}
        @media ${device.mobileS} {
            border-radius: 2px;
        }
    }
    ${p =>
      p.extrapadding &&
      `
        input{
            padding: 10px 16px 10px 100px !important;
        }
    `}
    ${div =>
      div.withoutLabel &&
      `
        margin-top: 11px;
    `}
    .ic_eye{
        position: absolute;
        right: 15px;
        top: 15px;
        cursor: pointer;
    }
`;

export const FlagCont = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100px;
  display: flex;
  border-radius: 4px 0 0 4px;
  align-items: center;
  padding-left: 10px;
`;
export const Flag = styled.span`
  width: 23px;
  height: 17px;
  flex-shrink: 0;
  margin-right: 8px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
export const Code = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #000;
`;

export const CalendarWrapper = styled.div(
  props => `
    display: flex;
    position: absolute;
    @media (max-width: 768px){
      top:1.2rem;
      left: 0;
    }
  `,
);

export const CalendarWrapperFrom = styled(CalendarWrapper)(
  props => `
    //margin-left: -21rem;
    @media (max-width: 768px){
      margin-left:0;
    }
  `,
);

export const FromTimeWrap = styled.div(
  props => `
    display: flex;
    align-items: center;
    cursor: pointer;  `,
);

export const FromTimeText = styled.p(
  props => `
    font-size: ${props.theme.font.base};
    color: #4A4A4A;
  `,
);

export const FromTimeMainText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font14};
    color: #2F281E;;
    margin-left: ${props.theme.spacing.base};
  `,
);

export const StatementTimeWrap = styled.div(
  props => `
    flex-direction: row;
    align-items: center;
  `,
);

export const StatementTimeInnerWrap = styled.div(
  props => `
    display: flex;
    border:1px #9B9B9B solid;
    border-radius: 4px;
    height: 40px;
    @media (max-width: 768px){
      position:relative;
    }
  `,
);

export const CommonSelect = styled.select(
  props => `
    width: 100%;
    height: 4.2rem;
    background-color: ${props.theme.colors.white.base};
    display: flex;
    appearance: none;
    -webkit-appearance: none;
    border-left: none !important;
    -moz-appearance: none;
    padding: ${props.theme.spacing.small.s5} ${props.theme.spacing.large.l30} ${
    props.theme.spacing.small.s5
  } ${props.theme.spacing.base};
    border: 1px solid ${props.theme.colors.grey.lightd0};
    background-color: ${props.theme.colors.white.base};
    border-radius: ${props.theme.misc.borderRadius.small};
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.grey.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    background-image: url('https://assets-gos3.goibibo.com/downarrow-1587111682.png');
    background-repeat: no-repeat;
    background-position: 95% 50%;
    background-size: 1.1rem auto;
    cursor: pointer;
    ::-ms-expand {
      display: none;
    }
  
    @media only screen and (min-width: 320px) and (max-width: 991px) {
      margin-bottom: ${props.theme.spacing.base};
      font-size: ${props.theme.font.large.font14};
    }
    border-color: ${props.hasError ? props.theme.colors.red.base : ''};
`,
);

export const TncText = styled.p`
  font-size: 14px;
  line-height: 24px;
  color: #000;
  margin-top: 20px;
  margin-bottom: 20px;
  span {
    font-weight: 900;
  }
`;

export const ErrorMsg = styled.p`
  color: #eb2026;
  font-size: 16px;
  font-weight: 400;
  margin-top: 18px;
`;

export const FieldErrorMessage = styled.p`
  color: #eb2026;
  font-size: 13px;
  font-weight: 400;
`;

export const HeadingText = styled.p`
  font-size: 32px;
  font-weight: 900;
`;

export const SubHeadingText = styled.p`
  font-size: 20px;
  font-weight: 500;
`;
